import { PortfolioInformation } from "types/PortfolioInformation";
import { createCustomAction } from "typesafe-actions";

const PORTFOLIOINFORMATION_DATA_LOAD = "PORTFOLIOINFORMATION/PORTFOLIOINFORMATION_DATA_LOAD";
const PORTFOLIOINFORMATION_DATA_LOAD_SUCCESS =
  "PORTFOLIOINFORMATION/PORTFOLIOINFORMATION_DATA_LOAD_SUCCESS";
const PORTFOLIOINFORMATION_DATA_LOAD_FAIL =
  "PORTFOLIOINFORMATION/PORTFOLIOINFORMATION_DATA_LOAD_FAIL";

export const load = createCustomAction(PORTFOLIOINFORMATION_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  PORTFOLIOINFORMATION_DATA_LOAD_SUCCESS,
  (type) => (data?: PortfolioInformation) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  PORTFOLIOINFORMATION_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
